module.exports = __webpack_public_path__ + "1c3450294d3284434dd364f0fa0fa56a.svg";